import { WithAuthorization } from "../../context";
import { useSearchParams } from "react-router-dom";
import { OrganizationQuestionnaire } from "./index";

function OrganizationQuestionnaireWrapper() {
  const [searchParams] = useSearchParams();
  const questionnaireId = searchParams.get("id");
  const viewMode = searchParams.get("view") === "true";

  return (
    <OrganizationQuestionnaire questionnaireId={questionnaireId} isOpenedInModal={false} viewOnly={viewMode} />
  )
}

export default WithAuthorization(OrganizationQuestionnaireWrapper);